"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationReminderPreviewDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class RegistrationReminderPreviewDto {}
exports.RegistrationReminderPreviewDto = RegistrationReminderPreviewDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Total Pending user accounts (not deleted)'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "pendingTotal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Pending non-internal users with a valid OneSignal device token (push-eligible)'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "eligibleCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Pending internal users with a valid device token. These are excluded from the re-engage blast.'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "excludedInternalCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eligible users who have never received a registration reminder'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "neverRemindedCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eligible users who already received at least one registration reminder'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "alreadyRemindedCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Most recent registrationReminderSentAt across all users'
}), __metadata("design:type", Object)], RegistrationReminderPreviewDto.prototype, "lastReminderSentAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Users who completed onboarding after a registration reminder sent in the last 30 days'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "returnedLast30Days", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Default message used when the admin does not override copy'
}), __metadata("design:type", String)], RegistrationReminderPreviewDto.prototype, "defaultMessage", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Default visible push heading shown on device lock screens'
}), __metadata("design:type", String)], RegistrationReminderPreviewDto.prototype, "defaultHeading", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Recipients per OneSignal request for this blast'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "batchSize", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Default pause in milliseconds between OneSignal batches'
}), __metadata("design:type", Number)], RegistrationReminderPreviewDto.prototype, "batchIntervalMs", void 0);
//# sourceMappingURL=RegistrationReminderPreview.dto.js.map